export default (params) => ({
  trigger: {
    name: 'mini_product_page.click_all_specifications',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_all',
      params: {
        sub_feature: 'specifications',
      },
    },
    nonInt: true,
  },
});
